import {observer} from 'mobx-react-lite';
import React from 'react';
import {ETooltip} from 'webapp-lib/Components';

const UUserInitialsWithTooltip = ({
  initials,
  displayName,
}: {
  initials: string;
  displayName: string;
}): React.ReactElement => (
  <ETooltip title={displayName}>
    <span>{initials}</span>
  </ETooltip>
);

export const UserInitialsWithTooltip = observer(UUserInitialsWithTooltip);
